var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"navbar-toggler menu-icon",class:{ active: _vm.isOpen },on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('span',{staticClass:"line"}),_c('span',{staticClass:"line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }